export default __webpack_public_path__ + "media/images/backgrounds/cta-christmas-trees-9e13e8244080881bea3c49ad4fd35160.png";